import React, { FC } from 'react';
import { SearchMobileModalProps } from './SearchMobile.types';
import SearchMobileModal from './SearchMobileModal';

const SearchMobileModalLazy: FC<SearchMobileModalProps> = props => {
  return (
    // <ErrorBoundary>
    //   <Suspense fallback={''}>
    <SearchMobileModal {...props} />
    //   {/* </Suspense>
    // </ErrorBoundary> */}
  );
};

export default SearchMobileModalLazy;
